import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { environment } from '../../../../environments/environment';

import {
  BrokerMandateDraftModel,
  BrokerMandateDraftStatusModel,
  BrokerMandateFooterModel,
  BrokerMandateWatermarkModel,
} from '../../model';

@Injectable({
  providedIn: 'root',
})
export class BrokerMandateDraftService {
  public triggerSave$ = new Subject<void>();

  constructor(private http: HttpClient) {}

  public getCurrentBrokerMandateDraft(): Observable<BrokerMandateDraftModel> {
    return this.http.get<BrokerMandateDraftModel>(`${environment.apiEndpoint}/account/broker-mandate/draft`);
  }

  public brokerMandateStatus(): Observable<BrokerMandateDraftStatusModel> {
    return this.http.get<BrokerMandateDraftStatusModel>(
      `${environment.apiEndpoint}/account/broker-mandate/publish-status`,
    );
  }

  public updateBrokerMandateDraft(
    type: 'BROKER_MANDATE' | 'POWER_OF_ATTORNEY' | 'PRIVACY_CONSENT',
    content: string,
  ): Observable<BrokerMandateDraftStatusModel> {
    return this.http.put<BrokerMandateDraftStatusModel>(
      `${environment.apiEndpoint}/account/broker-mandate/draft/${type}`,
      content,
    );
  }

  public updateBrokerMandateFooter(footer: BrokerMandateFooterModel): Observable<BrokerMandateDraftStatusModel> {
    return this.http.put<BrokerMandateDraftStatusModel>(
      `${environment.apiEndpoint}/account/broker-mandate/draft/footer`,
      footer,
    );
  }

  public updateBrokerMandateWatermark(
    watermark: BrokerMandateWatermarkModel,
  ): Observable<BrokerMandateDraftStatusModel> {
    return this.http.put<BrokerMandateDraftStatusModel>(
      `${environment.apiEndpoint}/account/broker-mandate/draft/watermark`,
      watermark,
    );
  }

  public publishBrokerMandate(): Observable<void> {
    return this.http.post<void>(`${environment.apiEndpoint}/account/broker-mandate/publish`, null);
  }

  public unpublishBrokerMandate(): Observable<void> {
    return this.http.post<void>(`${environment.apiEndpoint}/account/broker-mandate/unpublish`, null);
  }

  public generatePreviewPDF(type: 'BROKER_MANDATE' | 'POWER_OF_ATTORNEY' | 'PRIVACY_CONSENT'): Observable<Blob> {
    return this.http.get(`${environment.apiEndpoint}/account/broker-mandate/draft/${type}/preview`, {
      responseType: 'blob',
    });
  }

  public checkActiveBrokerMandate(): Observable<{ activeBrokerMandate: boolean }> {
    return this.http.get<{ activeBrokerMandate: boolean }>(
      `${environment.apiEndpoint}/account/broker-mandate/active-status`,
    );
  }

  // Subject for save from parent component
  public saveDraft(): void {
    this.triggerSave$.next();
  }
}
